<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="white-card">
        <div class="header-title-row" style="padding-bottom: 16px">
          <div class="header-left">
            <img
              src="assets/svg/dashboard-icon.svg"
              alt="dash"
              class="center-svg"
            />
            <h1 class="text-semibold color-org t-24">Inicio</h1>
          </div>

          <div class="header-actions">
            <div class="text-center event-item">
              <button class="btn btn-round-outline" (click)="reload()">
                <img class="center-svg" src="assets/svg/reload-icon-org.svg" />
              </button>
            </div>
            <button
              class="action-btn outline"
              (click)="openMdlCreateOportunity()"
            >
              <img src="assets/svg/plus-orange.svg" width="16" height="16" />
              Nueva oportunidad
            </button>
            <button
              class="action-btn outline"
              (click)="openMdlCreateContract()"
            >
              <img src="assets/svg/plus-orange.svg" width="16" height="16" />
              Nuevo contrato
            </button>
            <button class="action-btn primary" (click)="openMdlNewTask()">
              <img src="assets/svg/plus-icon.svg" width="16" height="16" />
              Nueva tarea
            </button>
          </div>


              <div *ngIf="userRole === 'Administrador' || userRole === 'admin'">
    <div class="d-grid progress-status-row mt-3">
            <div class="status-card-4">
              <div class="content-card-4">
                <div class="card-header">
                  <img
                    src="assets/svg/report-icon-1.svg"
                    alt="icono ingresadas"
                    class="card-icon"
                  />
                  <span class="card-title"
                    >Total de oportunidades en curso</span
                  >
                </div>
                <div class="card-body" style="text-align: center">
                  <b class="card-amount-bold">{{totalOportunidadesEnCurso | montoInteligente}}</b>
                </div>
              </div>
            </div>
            <div class="status-card-4">
              <div class="content-card-4">
                <div class="card-header">
                  <img
                    src="assets/svg/report-icon-1.svg"
                    alt="icono ingresadas"
                    class="card-icon"
                  />
                  <span class="card-title"
                    >Oportunidades cerradas este mes</span
                  >
                </div>
                <div class="card-body" style="text-align: center">
                  <b class="card-amount-bold">{{oportunidadesCerradas | montoInteligente}}</b>
                </div>
              </div>
            </div>
            <div class="status-card-4">
              <div class="content-card-4">
                <div class="card-header">
                  <img
                    src="assets/svg/report-icon-4.svg"
                    alt="icono ingresadas"
                    class="card-icon"
                  />
                  <span class="card-title">Metas del mes</span>
                </div>
                <div class="card-body" style="text-align: center">
                  <b class="card-amount-bold">{{metasDelMes | montoInteligente}}</b>
                </div>
              </div>
            </div>

            <div class="status-card-4">
              <div class="content-card-4">
                <div class="card-header">
                  <img
                    src="assets/svg/report-icon-2.svg"
                    alt="icono ingresadas"
                    class="card-icon"
                  />
                  <span class="card-title"
                    >%cumplimiento metas de este mes</span
                  >
                </div>
                <div class="card-body" style="text-align: center">
                  <b class="card-amount-bold">{{cumplimientoMetas}}</b>
                  %
                </div>
              </div>
            </div>

            <div class="status-card-4">
              <div class="content-card-4">
                <div class="card-header">
                  <img
                    src="assets/svg/report-icon-3.svg"
                    alt="icono ingresadas"
                    class="card-icon"
                  />
                  <span class="card-title">Tareas completadas</span>
                </div>
                <div class="card-body" style="text-align: center">
                  <b class="card-amount-bold">{{tareasCompletadas}}</b>
                </div>
              </div>
            </div>
          </div>
          </div>

                <div *ngIf="userRole === 'Ejecutivo'">
                      <div class="d-grid progress-status-row mt-3">
            <div class="status-card-4">
              <div class="content-card-4">
                <div class="card-header">
                  <img
                    src="assets/svg/report-icon-1.svg"
                    alt="icono ingresadas"
                    class="card-icon"
                  />
                  <span class="card-title"
                    >Total de oportunidades en curso</span
                  >
                </div>
                <div class="card-body" style="text-align: center">
                  <b class="card-amount-bold">{{totalOportunidadesEnCurso | montoInteligente}}</b>
                </div>
              </div>
            </div>
            <div class="status-card-4">
              <div class="content-card-4">
                <div class="card-header">
                  <img
                    src="assets/svg/report-icon-1.svg"
                    alt="icono ingresadas"
                    class="card-icon"
                  />
                  <span class="card-title"
                    >Oportunidades cerradas este mes</span
                  >
                </div>
                <div class="card-body" style="text-align: center">
                  <b class="card-amount-bold">{{oportunidadesCerradas | montoInteligente}}</b>
                </div>
              </div>
            </div>
            <div class="status-card-4">
              <div class="content-card-4">
                <div class="card-header">
                  <img
                    src="assets/svg/report-icon-4.svg"
                    alt="icono ingresadas"
                    class="card-icon"
                  />
                  <span class="card-title">Metas del mes</span>
                </div>
                <div class="card-body" style="text-align: center">
                  <b class="card-amount-bold">{{metasDelMes | montoInteligente}}</b>
                </div>
              </div>
            </div>

            <div class="status-card-4">
              <div class="content-card-4">
                <div class="card-header">
                  <img
                    src="assets/svg/report-icon-3.svg"
                    alt="icono ingresadas"
                    class="card-icon"
                  />
                  <span class="card-title">Tareas completadas</span>
                </div>
                <div class="card-body" style="text-align: center">
                  <b class="card-amount-bold">{{tareasCompletadas}}/{{totalTareas}}</b>
                </div>
              </div>
            </div>
          </div>








                </div>


      



        </div>
      </div>
      <!-- ===================== 📊 DASHBOARD ADMIN ===================== -->
      <div *ngIf="userRole === 'Administrador' || userRole === 'admin'">
        <div class="white-card mt-4">
          <div class="d-grid gg-mdl-header" style="grid-template-columns: auto 1fr">
            <div class="gg-center-svg">
              <img src="assets/svg/charts-icon.svg" style="width: 46px; height: 46px" />
            </div>
            <div>
              <h4 class="text-semibold" style="font-size: 20px">Tendencia anual de cumplimiento</h4>
              <div class="underline-org"></div>
            </div>
          </div>

          <div class="gg-chart-container">
            <canvas baseChart [type]="'line'" [data]="annualLine.data" [options]="annualLine.options" style="width: 100% !important; max-width: 100%;"></canvas>
          </div>
        </div>

        <div class="dashboard-grid mt-4">
          <div class="white-card">
            <h4 class="text-semibold mb-2">Top Ejecutivos</h4>
            <div class="underline-org"></div>
            <div class="gg-chart-container">
              <canvas baseChart [type]="'bar'" [data]="execBar.data" [options]="execBar.options" style="width: 100% !important; max-width: 100%;"></canvas>
            </div>
          </div>

          <div class="white-card">
            <h4 class="text-semibold mb-2">Top Cuentas</h4>
            <div class="underline-org"></div>
            <div class="gg-chart-container">
              <canvas baseChart [type]="'bar'" [data]="topAccounts.data" [options]="topAccounts.options" style="width: 100% !important; max-width: 100%;"></canvas>
            </div>
          </div>

          <div class="white-card">
            <h4 class="text-semibold mb-2">Avance mensual</h4>
            <div class="underline-org"></div>
            <div class="gg-chart-container">
              <canvas baseChart [type]="'line'" [data]="monthlyLine.data" [options]="monthlyLine.options" style="width: 100% !important; max-width: 100%;"></canvas>
            </div>
          </div>
        </div>
      </div>

      <!-- =====================  DASHBOARD EJECUTIVO ===================== -->
      <div *ngIf="userRole === 'Ejecutivo'">
        <div class="forecast-graphic">
            <div class="chart-container">
              <div class="d-grid align-center" style="grid-template-columns: auto 1fr; align-items: center; gap: 10px;">
                  <img src="assets/svg/charts-icon.svg" alt="">
                  <h2 class="t-20 text-semibold">Tendencia anual de cumplimiento de metas</h2>
              </div>
              <div class="org-hr mt-3" style="background-color: #EA5A10; min-height: 2px;"></div>
                <canvas
                  baseChart
                  [type]="'line'"
                  [data]="annualLine.data"
                  [options]="annualLine.options"
                  style="width: 100% !important; max-width: 100%;"
                ></canvas>
            </div>
        </div>

        <div class="dashboard-grid">
          <div class="white-card">
            <div class="d-grid gg-mdl-header" style="grid-template-columns: auto 1fr">
              <div class="gg-center-svg">
                <img
                  src="assets/svg/charts-icon.svg"
                  style="width: 46px; height: 46px"
                />
              </div>
              <div>
                <h4 class="text-semibold" style="font-size: 20px">
                  Top cuentas anuales
                </h4>
              </div>
            </div>
            <div class="forecast-graphic">
              <div class="gg-chart-container">
                <canvas
                  baseChart
                  [type]="'bar'"
                  [data]="topAccounts.data"
                  [options]="topAccounts.options"
                  style="width: 100% !important; max-width: 100%;"
                ></canvas>
              </div>
            </div>
          </div>

          <div class="white-card">
            <div class="d-grid gg-mdl-header" style="grid-template-columns: auto 1fr">
              <div class="gg-center-svg">
                <img
                  src="assets/svg/charts-icon.svg"
                  style="width: 46px; height: 46px"
                />
              </div>
              <div>
                <h4 class="text-semibold" style="font-size: 20px">
                  Avance mensual de metas
                </h4>
              </div>
            </div>

            <div class="gg-chart-container">
              <canvas
                baseChart
                [type]="'line'"
                [data]="monthlyLine.data"
                [options]="monthlyLine.options"
                style="width: 100% !important; max-width: 100%;"
              ></canvas>
            </div>
          </div>

          <div class="white-card">
            <div class="d-grid gg-mdl-header" style="grid-template-columns: auto 1fr">
              <div class="gg-center-svg">
                <img
                  src="assets/svg/charts-icon.svg"
                  style="width: 46px; height: 46px"
                />
              </div>
              <div>
                <h4 class="text-semibold" style="font-size: 20px">
                  Porcentaje de cumplimiento de tareas
                </h4>
              </div>
            </div>

            <div class="gg-chart-container">
              <canvas
                baseChart
                [type]="'doughnut'"
                [data]="taskProgress.data"
                [options]="taskProgress.options"
                style="width: 100% !important; max-width: 100%;"
              ></canvas>
            </div>
          </div>
        </div>

      </div>



      <div class="dashboard-grid">
        <div class="white-card">
          <div class="d-flex align-center justify-between mb-2 header-left">
            <h4
              class="text-semibold"
              style="
                font-size: 18px;
                display: flex;
                align-items: center;
                gap: 8px;
              "
            >
              <img
                src="assets/svg/notification-bell-icon.svg"
                width="28"
                height="28"
              />
              Notificaciones
            </h4>
            <span class="ver-todas"><a href="#" (click)="markAllNotificationsAsRead(); $event.preventDefault()">Marcar como leídas</a></span>
          </div>

          <div class="notification-list" style="padding-top: 15px;">
            <div
              *ngFor="let n of notifications; let last = last"
              class="notification-item"
              [ngClass]="n.tipo"
              (click)="goToNotification(n)"
              >
              <div class="notif-icon">
                <img
                  [src]="
            n.tipo === 'error'
              ? 'assets/svg/notification-fail.svg'
              : n.tipo === 'alerta'
              ? 'assets/svg/notification-warning.svg'
              : n.tipo === 'ok'
              ? 'assets/svg/notification-good.svg'
              : 'assets/svg/notification-flag.svg'
          "
                  width="22"
                />
              </div>

              <div class="notif-content">
                <div class="notif-header">
                  <b>{{ n.titulo }}</b>
                  <small>{{ n.tiempo }}</small>
                </div>
                <div class="notif-desc">{{ n.descripcion }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="white-card tareas-card">
          <div class="header-card">
            <div class="header-left">
              <img src="assets/svg/task-icon-orange.svg" alt="icono tareas" />
              <h3 class="text-semibold">Resumen de tareas</h3>
            </div>
            <span class="ver-todas"><a href="/tasks">Ver todas</a></span>
          </div>

          <div class="tareas-section" [class.open]="openSection === 'dia'">
            <div class="section-header" (click)="toggleSection('dia')">
              <span>Tareas del día</span>
              <img class="arrow-icon" src="assets/svg/arrow-down.svg" />
            </div>

            <div class="section-body">
              <div class="empty-state" *ngIf="tareasDelDia.length === 0">
                No hay tareas para hoy.
              </div>
              <div class="tarea-box" *ngFor="let tarea of tareasDelDia">
                <div class="tarea-header">
                  <div class="tarea-left">
                    <div [ngSwitch]="tarea.tipo">
                      <img
                        *ngSwitchCase="'llamada'"
                        src="assets/svg/call-icon-orange.svg"
                        alt="llamada"
                      />
                      <img
                        *ngSwitchCase="'evento'"
                        src="assets/svg/new-event-icon.svg"
                        alt="evento"
                      />
                      <img
                        *ngSwitchCase="'email'"
                        src="assets/svg/new-email-icon.svg"
                        alt="email"
                      />
                      <img
                        *ngSwitchDefault
                        src="assets/svg/task-orange-circle.svg"
                        alt="Tarea"
                      />
                    </div>
                    <div>
                      <h4 class="titulo-tarea">{{ tarea.titulo }}</h4>
                      <p class="detalle">
                        Hora: <b>{{ tarea.hora_vencimiento }} hrs</b> &nbsp; |
                        &nbsp; Prioridad:
                        <span
                          class="prioridad"
                          [ngClass]="getPriorityClass(tarea.prioridad)"
                        >
                          {{ tarea.prioridad }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <span class="vence"
                    >Vence: {{ tarea.fecha_vencimiento | date:'dd/MM/yyyy'
                    }}</span
                  >
                </div>

                <div class="tarea-footer">
                  <button class="accion reprogramar">
                    <img src="assets/svg/calendar-icon.svg" /> Reprogramar
                  </button>
                  <button class="accion completar">
                    <img src="assets/svg/check-icon.svg" /> Completar
                  </button>
                  <a
                    class="ver-mas"
                    (click)="verDetalleTarea(tarea.tarea_id, $event)"
                    >Ver más
                    <img src="assets/svg/arrow-right.svg" alt="Ver más"
                  /></a>
                </div>
              </div>
            </div>
          </div>

          <div class="tareas-section" [class.open]="openSection === 'proximas'">
            <div class="section-header" (click)="toggleSection('proximas')">
              <span>Tareas próximas</span>
              <img class="arrow-icon" src="assets/svg/arrow-down.svg" />
            </div>

            <div class="section-body">
              <div class="empty-state" *ngIf="tareasProximas.length === 0">
                No hay tareas próximas.
              </div>
              <div class="tarea-box" *ngFor="let tarea of tareasProximas">
                <div class="tarea-header">
                  <div class="tarea-left">
                    <div [ngSwitch]="tarea.tipo">
                      <img
                        *ngSwitchCase="'llamada'"
                        src="assets/svg/call-icon-orange.svg"
                        alt="llamada"
                      />
                      <img
                        *ngSwitchCase="'evento'"
                        src="assets/svg/new-event-icon.svg"
                        alt="evento"
                      />
                      <img
                        *ngSwitchCase="'email'"
                        src="assets/svg/new-email-icon.svg"
                        alt="email"
                      />
                      <img
                        *ngSwitchDefault
                        src="assets/svg/task-orange-circle.svg"
                        alt="Tarea"
                      />
                    </div>
                    <div>
                      <h4 class="titulo-tarea">{{ tarea.titulo }}</h4>
                      <p class="detalle">
                        Hora: <b>{{ tarea.hora_vencimiento }} hrs</b> &nbsp; |
                        &nbsp; Prioridad:
                        <span
                          class="prioridad"
                          [ngClass]="getPriorityClass(tarea.prioridad)"
                        >
                          {{ tarea.prioridad }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <span class="vence"
                    >Vence: {{ tarea.fecha_vencimiento | date:'dd/MM/yyyy'
                    }}</span
                  >
                </div>

                <div class="tarea-footer">
                  <button class="accion reprogramar">
                    <img src="assets/svg/calendar-icon.svg" /> Reprogramar
                  </button>
                  <button class="accion completar">
                    <img src="assets/svg/check-icon.svg" /> Completar
                  </button>
                  <a
                    class="ver-mas"
                    (click)="verDetalleTarea(tarea.tarea_id, $event)"
                    >Ver más
                    <img src="assets/svg/arrow-right.svg" alt="Ver más"
                  /></a>
                </div>
              </div>
            </div>
          </div>

          <div class="tareas-section" [class.open]="openSection === 'vencidas'">
            <div class="section-header" (click)="toggleSection('vencidas')">
              <span>Tareas vencidas</span>
              <img class="arrow-icon" src="assets/svg/arrow-down.svg" />
            </div>

            <div class="section-body">
              <div class="empty-state" *ngIf="tareasVencidas.length === 0">
                No hay tareas vencidas.
              </div>
              <div class="tarea-box" *ngFor="let tarea of tareasVencidas">
                <div class="tarea-header">
                  <div class="tarea-left">
                    <div [ngSwitch]="tarea.tipo">
                      <img
                        *ngSwitchCase="'llamada'"
                        src="assets/svg/call-icon-orange.svg"
                        alt="llamada"
                      />
                      <img
                        *ngSwitchCase="'evento'"
                        src="assets/svg/new-event-icon.svg"
                        alt="evento"
                      />
                      <img
                        *ngSwitchCase="'email'"
                        src="assets/svg/new-email-icon.svg"
                        alt="email"
                      />
                      <img
                        *ngSwitchDefault
                        src="assets/svg/task-orange-circle.svg"
                        alt="Tarea"
                      />
                    </div>
                    <div>
                      <h4 class="titulo-tarea">{{ tarea.titulo }}</h4>
                      <p class="detalle">
                        Hora: <b>{{ tarea.hora_vencimiento }} hrs</b> &nbsp; |
                        &nbsp; Prioridad:
                        <span
                          class="prioridad"
                          [ngClass]="getPriorityClass(tarea.prioridad)"
                        >
                          {{ tarea.prioridad }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <span class="vence"
                    >Vence: {{ tarea.fecha_vencimiento | date:'dd/MM/yyyy'
                    }}</span
                  >
                </div>

                <div class="tarea-footer">
                  <button class="accion reprogramar">
                    <img src="assets/svg/calendar-icon.svg" /> Reprogramar
                  </button>
                  <button class="accion completar">
                    <img src="assets/svg/check-icon.svg" /> Completar
                  </button>
                  <a
                    class="ver-mas"
                    (click)="verDetalleTarea(tarea.tarea_id, $event)"
                    >Ver más
                    <img src="assets/svg/arrow-right.svg" alt="Ver más"
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="white-card">
          <div class="d-flex align-center justify-between mb-2">
            <h4
              class="text-semibold"
              style="
                font-size: 18px;
                display: flex;
                align-items: center;
                gap: 8px;
              "
            >
              <img
                src="assets/svg/opportunities-icon.svg"
                width="28"
                height="28"
              />
              Oportunidades en curso
            </h4>
            <a href="/opportunities" class="color-org">Ver todas</a>
          </div>

          <div *ngIf="isLoading" class="loading-text">
            Cargando oportunidades...
          </div>
          <div *ngIf="errorMessage" class="error-text">{{ errorMessage }}</div>

          <div class="opportunity-list" style="padding-top: 15px;">
            <div *ngFor="let o of oportunidades" class="opportunity-item">
              <div class="opp-header">
                <div class="opp-title">
                  <img
                    [src]="o.icono || 'assets/svg/opportunities-icon.svg'"
                    width="20"
                  />
                  <b>{{ o.nombre }}</b>
                </div>
              </div>

              <div class="opp-details">
                <div>Etapa actual: <b>{{ o.estado?.nombre }}</b></div>
                <div>
                  Fecha de cierre estimada:
                  <b>{{ o.fecha_cierre_estimada | date:'dd/MM/yyyy' }}</b>
                </div>
                <div>
                  Creado por:
                  <span class="creator">
                    <img src="assets/svg/user-icon.svg" width="16" /> {{
                    o.creadoPor.nombre }} {{o.creadoPor.apellido}}
                  </span>
                  <small
                    >{{ o.fecha_creacion | date:'dd/MM/yyyy HH:mm' }}</small
                  >
                </div>
                <div>
                  Monto estimado:
                  <b class="text-semibold"
                    >{{ o.importe_actual | currency:'CLP':'symbol':'1.0-0' }}</b
                  >
                </div>
              </div>

              <div class="opp-footer">
                <a
                  class="ver-mas"
                  (click)="verDetalleOportunidad(o.oportunidad_id, $event)"
                  >Ver más <img src="assets/svg/arrow-right.svg"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="dashboard-grid">
        <div class="white-card">
          <div class="d-flex align-center justify-between mb-2">
            <h4
              class="text-semibold"
              style="
                font-size: 18px;
                display: flex;
                align-items: center;
                gap: 8px;
              "
            >
              <img src="assets/svg/contract-icon.svg" width="28" height="28" />
              Contratos próximos a vencer
            </h4>
          </div>

          <div class="contract-list" style="padding-top: 15px;">
            <div
              *ngFor="let contrato of contratosProximos"
              class="contract-item"
            >
              <div class="contract-header">
                <div class="contract-left">
                  <div class="contract-list-icon">
                    <img src="assets/svg/contract-icon.svg" />
                  </div>
                  <div class="contract-id">#{{ contrato.numero_contrato }}</div>
                </div>

                <div class="badge danger">
                  Fecha expiración: {{ contrato.fecha_expiracion |
                  date:'dd/MM/yyyy' }}
                </div>
              </div>

              <div class="contract-details">
                <p>Etapa actual: {{ contrato.estado }}</p>
                <p>Duración contrato: {{ contrato.duracion_meses }} meses</p>
                <p>
                  Creado por:
                  <span class="creator"
                    >{{ contrato.creadoPor.nombre }}{{
                    contrato.creadoPor.apellido }}</span
                  >
                  {{ contrato.fecha_creacion | date:'dd/MM/yyyy HH:mm' }}
                </p>
              </div>
              <div class="opp-footer">
                <a
                  class="color-org ver-mas"
                  (click)="verDetalleContrato(contrato.contrato_id, $event)"
                  >Ver más <img src="assets/svg/arrow-right.svg"
                /></a>
              </div>
            </div>
          </div>
          <div class="footer-card text-center">
            <a href="/contracts" class="color-org">Ver todos</a>
          </div>
        </div>

        <div class="white-card">
          <div class="d-flex align-center justify-between mb-2">
            <h4
              class="text-semibold"
              style="
                font-size: 18px;
                display: flex;
                align-items: center;
                gap: 8px;
              "
            >
              <img
                src="assets/svg/opportunities-icon.svg"
                width="28"
                height="28"
              />
              Oportunidades sin avances recientes
            </h4>
          </div>

          <div class="opportunity-list" style="padding-top: 15px;">
            <div
              *ngFor="let o of oportunidadesSinAvance"
              class="opportunity-item"
            >
              <div class="opp-header">
                <div class="opp-title">
                  <img src="assets/svg/opportunities-icon.svg" width="20" />
                  <b>{{ o.nombre }}</b>
                </div>
                <span class="badge riesgo"
                  >{{ o.diasSinAvance }} días sin avances</span
                >
              </div>

              <div class="opp-details">
                <div>Etapa actual: <b>{{ o.estado.nombre }}</b></div>
                <div>
                  Fecha de creación:
                  <b>{{ o.fecha_creacion | date:'dd/MM/yyyy' }}</b>
                </div>
              </div>

              <div class="opp-footer">
                <div>
                  Creado por:
                  <span class="creator"
                    >{{ o.creadoPor.nombre }}{{o.creadoPor.apellido}}</span
                  >
                  {{ o.fecha_creacion | date:'dd/MM/yyyy HH:mm' }}
                </div>
                <a
                  class="color-org ver-mas"
                  (click)="verDetalleOportunidad(o.oportunidad_id, $event)"
                  >Ver más <img src="assets/svg/arrow-right.svg"
                /></a>
              </div>
            </div>
            <div class="footer-card text-center">
              <a href="/opportunities" class="color-org">Ver todos</a>
            </div>
          </div>
        </div>

        <div class="white-card">
          <div class="d-flex align-center justify-between mb-2">
            <h4
              class="text-semibold"
              style="
                font-size: 18px;
                display: flex;
                align-items: center;
                gap: 8px;
              "
            >
              <img src="assets/svg/account.svg" width="28" height="28" />
              Cuentas y contactos sin interacciones
            </h4>
          </div>

          <div class="opportunity-list" style="padding-top: 15px;">
            <div
              *ngIf="cuentasContactos.length === 0 && !isLoading"
              class="text-center color-gray py-3"
            >
              No se encontraron cuentas o contactos sin interacciones.
            </div>

            <div *ngFor="let item of cuentasContactos" class="opportunity-item">
              <div class="opp-header">
                <div class="opp-title">
                  <img
                    [src]="item.tipo === 'cuenta'
              ? 'assets/svg/account.svg'
              : 'assets/svg/contact-icon.svg'"
                    width="20"
                  />
                  <b>{{ item.nombre }}</b>
                </div>
                <a
                  class="color-org ver-mas"
                  (click)="
    item.tipo === 'cuenta'
      ? verDetalleCuenta(item.id, $event)
      : verDetalleContacto(item.id, $event)
  "
                >
                  Ver más <img src="assets/svg/arrow-right.svg" />
                </a>
              </div>

              <div class="opp-details">
                <div>
                  Última modificación:
                  <b>{{ item.fecha | date:'dd/MM/yyyy' }}</b>
                </div>
                <div>
                  Creado por:
                  <span class="creator">
                    {{ item.creadoPor?.nombre }} {{ item.creadoPor?.apellido }}
                  </span>
                  {{ item.fecha | date:'dd/MM/yyyy HH:mm' }}
                </div>
              </div>
            </div>
            <div class="footer-card text-center">
              <a href="/contacts" class="color-org">Ir a contactos</a>
              <span> | </span>
              <a href="/accounts" class="color-org">Ir a cuentas</a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>